import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

// Shared by every registration form (ParentConsent, StaffRegistration,
// DancerRegistration, ...) — a single checkbox + label, with an optional
// error caption underneath. Module-scoped (not defined inside a form
// component) so it keeps a stable component identity across renders — if it
// were redefined on every render of the parent, React would unmount and
// remount every checkbox on each keystroke, breaking focus/Tab order.
export default function CheckItem({ checked, onChange, error, label }) {
  return (
    <FormControlLabel
      sx={{ alignItems: 'flex-start', display: 'flex' }}
      control={
        <Checkbox size="small" sx={{ mt: -1, alignSelf: 'flex-start' }}
          checked={checked} onChange={onChange} />
      }
      label={
        <Box>
          <Typography variant="body2">{label}</Typography>
          {error && <Typography variant="caption" color="error">{error}</Typography>}
        </Box>
      }
    />
  );
}
